module.exports = "<app-alerts [mode]=\"reports\"  [searchInput]=\"search\" [commonData]='gridView' ></app-alerts>"